import { createAction } from '@reduxjs/toolkit';

export const UPDATE_USER_ACTION_TYPE = 'saga/updateUser';
export const updateUserAction = createAction(UPDATE_USER_ACTION_TYPE);
